export const isInstanceOf =
    <T>(ctor: abstract new (...args: never[]) => T) =>
    (value: unknown): value is T =>
        value instanceof ctor
